<template>
  <div>
    <Layout/>
    <h4>Planes</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idPlan" class="form-label">IdPlan</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idPlan" name="idPlan" v-model="datoPlan.idPlan" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoPlan.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="descripcion" class="form-label">Descripción</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="descripcion" name="descripcion" v-model="datoPlan.descripcion" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="precio" class="form-label">Precio</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="precio" name="precio" v-model="datoPlan.precio" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoPlan.fechaReg" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" @click.prevent="cerrarPlan" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarPlan" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditPlan" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdModuPlan</th>
          <th scope="col">IdModulo</th>
          <th scope="col">IdPlan</th>
          <th scope="col">Estado</th>
          <th scope="col">PlanNombre</th>
          <th scope="col">ModuloNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="moduplan in datosPaginados" :key="moduplan.idModuPlan">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(moduplan.idModuPlan)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(moduplan.idModuPlan)" title="Editar">edit_square</i></td>
          <td>{{moduplan.idModuPlan}}</td>
          <td>{{moduplan.idModulo}}</td>
          <td>{{moduplan.idPlan}}</td>
          <td>{{moduplan.estado}}</td>
          <td>{{moduplan.planNombre}}</td>
          <td>{{moduplan.moduloNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deletePlan(moduplan.idModuPlan)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idModuPlan" class="form-label">IdModuPlan</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idModuPlan" name="idModuPlan" v-model="datoModuPlan.idModuPlan" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idModulo" name="idModulo" v-model="datoModuPlan.idModulo"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idModulo" class="form-label"> Modulo</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="modulo" name="modulo" v-model="datoModuPlan.modulo" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalModuloLOV"
                      title="Buscar Módulos">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idPlan" class="form-label">IdPlan</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idPlan" name="idPlan" v-model="datoModuPlan.idPlan" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarModuPlan" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditModuPlan" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

<!--
Listas de valores master
-->
<!--
Listas de valores master
-->
<!--
Listas de valores details
-->
<!-- Lista de Valores: ModuPlan -->
    <ModuPlanLOVdet @DatosModuPlan="GetDataModuPlanLOVdet($event)"/>
<!-- Lista de Valores: Modulo -->
    <ModuloLOVdet @DatosModulo="GetDataModuloLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import dateFormat from '@/modules/dateFormat.js';
// Listas de valores master
// Listas de valores master
// Listas de valores details
import ModuPlanLOVdet from '../../components/lovs/ModuPlanLOV.vue'
import ModuloLOVdet from '../../components/lovs/ModuloLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
// Listas de valores master
// Listas de valores master
// Listas de valores details
, ModuPlanLOVdet
, ModuloLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      plans : [],
      datoPlan : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idPlan: '',
// Variables master
// Variables details
      moduplans : [],
      datoModuPlan : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idPlan = this.$route.params.p_idplan
    this.abrirEditar(this.p_idPlan)
    this.getModuPlans()
    this.getDataPagina(this.paginaActual)
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      if(this.datoPlan.idPlan === ''){
        swal("Error!", "El elemento idPlan no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPlan.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPlan.descripcion === ''){
        swal("Error!", "El elemento descripcion no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPlan.precio === ''){
        swal("Error!", "El elemento precio no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPlan.fechaReg === ''){
        swal("Error!", "El elemento fechaReg no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPlan.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarPlan(){
      if(this.validarForm() === 1){
        try {
          await api.post('/plans', this.datoPlan)
          swal("Correcto!", "Plan creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditPlan(){
      if(this.validarForm() === 1){
        try {
          await api.post('/plans', this.datoPlan)
          swal("Correcto!", "Plan creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoPlan={}
      this.titulo   = 'Crear Planes'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idPlan){
      this.modalWindow = true
      if(idPlan != null){    
           api.get('/vwplans/'+idPlan).then(resp=>{
          this.datoPlan = resp.data;
           });
      }
      this.titulo   = 'Editar Planes'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarPlan(){
      this.$router.push('/Plan')
    },
// Procedimientos master
// Procedimientos detalle
    async getModuPlans() {
      const resp = await api.get('/moduplans')
      this.moduplans = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.moduplans.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwmoduplans/nombre/'+this.nombreBusqueda).then(response=>{
          this.moduplans=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.moduplans.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwmoduplans').then(response=>{
      this.moduplans=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.moduplans.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      if(this.datoModuPlan.idPlan === ''){
        swal("Error!", "El elemento idPlan no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoModuPlan.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoModuPlan.descripcion === ''){
        swal("Error!", "El elemento descripcion no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoModuPlan.precio === ''){
        swal("Error!", "El elemento precio no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoModuPlan.fechaReg === ''){
        swal("Error!", "El elemento fechaReg no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoModuPlan.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarModuPlan(){
      if(this.validarForm() === 1){
        try {
          this.datoModuPlan.idPlan = this.datoPlan.idPlan;
          await api.post('/moduplans', this.datoModuPlan)
          this.getModuPlans();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "ModuPlan creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditModuPlan(){
      if(this.validarForm() === 1){
        try {
          await api.post('/moduplans', this.datoModuPlan)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "ModuPlan creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoModuPlan={}
      this.titulo   = 'Crear Planes'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idModuPlan){
      this.modalWindow = true
      if(idModuPlan != null){    
           api.get('/vwmoduplans/'+idModuPlan).then(resp=>{
          this.datoModuPlan = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Planes'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idModuPlan){
      this.modalWindow = true
      if(idModuPlan != null){
        this.$router.push('/moduplanmd/'+idModuPlan)
      }
    },
    async deleteModuPlan (idModuPlan) {
      try{
        await api.delete('/moduplans/'+idModuPlan)
          this.getModuPlans()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
// Listas de valores master
// Listas de valores master
// Listas de valores details
//    Lista de Valores
    GetDataModuPlanLOVdet(data) {
      this.datoModuPlan.idModuPlan = data.idModuPlan;
      this.datoModuPlan.moduPlan = data.nombre;
    },
//    Lista de Valores
    GetDataModuloLOVdet(data) {
      this.datoModuPlan.idModulo = data.idModulo;
      this.datoModuPlan.modulo = data.nombre;
    },
// Listas de valores details
  },
}
</script>
